import { useLocation, useNavigate } from "react-router-dom";
import { useMemo, useCallback } from "react";

const useUrlParamState = (
  key: string,
  fallback: string = "",
): [string, (newValue: string | null | undefined) => void] => {
  const location = useLocation();
  const navigate = useNavigate();

  const value = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get(key) || fallback;
  }, [location.search, key, fallback]);

  const setValue = useCallback(
    (newValue: string | null | undefined) => {
      const params = new URLSearchParams(location.search);
      const current = params.get(key);

      if (newValue === null || newValue === undefined || newValue === "") {
        if (current === null) return;
        params.delete(key);
      } else {
        if (current === newValue) return;
        params.set(key, newValue);
      }

      navigate(
        {
          pathname: location.pathname,
          search: params.toString(),
        },
        { replace: false },
      ); // replace: false ensures a new history entry
    },
    [navigate, key, location],
  );

  return [value, setValue];
};

export default useUrlParamState;
